export default {
  text: 'Verifică cu {{provider}}',
  text_generic: 'Verifică cu furnizorul tău de plăți',
  error: 'Nu am putut deschide formularul {{provider}}. Te rugăm să încerci din nou.',
  error_generic: 'Nu am putut deschide formularul furnizorului de plăți. Te rugăm să încerci din nou.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
